export default {
	"dashboard": {
		"all": "all",
		"own": "own",
		"noConfirm": "To be confirmed",
		"noPlan": "To be planned",
		"distribution": "delivery",
		"distributionPlan": "delivery plan",
		"noDispatch": "To be scheduled",
		"execute": "Execution",
		"pending": "Pending",
		"tempMonitor": "temperature monitoring",
		"monitoringRate": "rate of monitor",
		"tempUpToStandard": "meet standard",
		"upToStandardRate": "compliance rate",
		"timeUpToStandard": "meet time requirement",
		"today": "today",
		"yesterday": "yesterday",
		"clickMarkRead": "click to mark as readed",
		"doubleClickToTeadMore": "double click to read the specific content",
		"noWarningMessage": "no warning message yet",
		"noRemindMessage": "no reminder message yet",
		"noNoticeMessage": "no notification message yet",
		"gotIt": "understood",
		"clickDownload": "click to download",
		"quotation": "quotation",
		"trunkLinePlan": "linehaul plan",
		"transportPlan": "shipping plan",
		"refreshInSeconds": "refresh in seconds",
		"shippingOrder": "Shipping Order",
		"plan": "Plan",
		"schedule": "Schedule",
		"abnormal": "Abnormal",
		"receipt": "Receipt",
		"notPickedUp": "Not picked up",
		"undelivered": "Undelivered",
		"driver": "Driver",
		"new": "New",
		"shipments": "Shipments",
		"vehicle": "Vehicle",
		"null": "Null",
		"NoTrackingInformation": "No Tracking Information!",
		"from": "from",
		"to": "to",
		"displayOnlyActiveJobs": "Display only Active Jobs ",
		"jobOnTheWay": "Job_ontheway",
		"jobHandingOver": "Job_handing_over",
		"waitingForAccept": "Waiting for Accept",
		"notArriveOrigin": "NOT Arrive Origin",
		"waitingForPickingUp": "Waiting for Picking Up",
		"waitingForDeparture": "Waiting for Departure",
		"notArriveDestination": "NOT Arrive Destination",
		"waitingForUnloading": "Waiting for Unloading",
		"waitingForDelivering": "Waiting for Delivering",
		"deliverySummary": "Delivery Summary",
		"noIssue": "No Issue",
		"nearDue": "Near Due",
		"overdue": "Overdue",
		"totalCreated": "Total Created",
		"delivered": "Delivered",
		"notAssigned": "NOT Assigned",
		"incident": "Incident",
		"newAbnormal": "New",
		"pending": "Pending",
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/dashboard/dashboard.js